import React from "react";
import StepWizard from "react-step-wizard";
import { Col } from "reactstrap";
import moment from "moment";
import { forEachSeries, map } from 'p-iteration';
// wizard steps
import Step1 from "./WizardSteps/Step1.js";
import Step2 from "./WizardSteps/Step2.js";
import Step3 from "./WizardSteps/Step3.js";
// Context
import ProjectContext from "contexts/ProjectContext";
// Helpers
import { exportToExcel } from "helpers/export";
// Requests
import { 
  getUnitsRequest,
  getUnitTotalPaidRequest,
  getUnitTotalCostRequest
} from "api/units";

class Reports extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      reportType: null,
      isLoading: false,
      successMessage: null,
      errorMessage: null,
      selectedProject: null
    };
  }
  static contextType = ProjectContext;

  componentDidMount() {
		this.previousContext = this.context;
		const { selectedProject } = this.context

		this.setState({ selectedProject });
	}

  setReportType = (reportType) => {
    this.setState({ reportType });
  }

  onChangeField = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  generateReport = async () => {
    console.log("Generating report...", this.state.reportType);
    if (this.state.reportType.value === "unitCost") {
      
      await this.generateUnitCostReport();

    } else if (this.state.reportType.value === "zeroVatClients") {
      await this.generateZeroVatClientsReport();
    }
  }

  generateUnitCostReport = async () => {
    
    console.log("Generating unit cost report...");

    try {
      this.setState({ isLoading: true })

      // Constants
      const startYear = 2014;
      const endYear = Number(moment().format('YYYY'));

      // 1.Fetch all units
      const allUnitsRequest = await getUnitsRequest({
        limit: 100,
        project: this.state.selectedProject
      });

      const filteredUnits = allUnitsRequest.units.filter((unit) => {
        return (
          unit.selectedModel && 
          unit.selectedModel.tcp &&
          unit.selectedModel.tcp > 0 &&
          unit.status !== "available"
        );
      });

      const reportEntries = await map(filteredUnits, async (unit) => {
        const unitInstance = unit;
        const clientInstance = unit.client;

        const reportEntry = {
          "Client": clientInstance ? `${clientInstance.first_name} ${clientInstance.last_name}` : 'N/A',
          "B#-L#-unit": `${unitInstance.block_number}-${unitInstance.lot_number}-${unitInstance.lot_area}`, 
          "Unit Id": unitInstance._id,
          "TCP": unitInstance.selectedModel.tcp ? unitInstance.selectedModel.tcp : 'N/A',
        };

        let totalLandCost = 0;
        let totalLandDevCost = 0;
        let totalConstructionCost = 0;

        await forEachSeries(Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i), async (year) => {
          const yearPaidResponse = await getUnitTotalPaidRequest(unitInstance._id, year);
          const yearCostResponse = await getUnitTotalCostRequest(unitInstance._id, year, yearPaidResponse.percentageOfTcp);
          reportEntry[`${year}-Amount Paid`] = yearPaidResponse.amountPaid ? yearPaidResponse.amountPaid : '-';
          reportEntry[`${year}-%`] = yearPaidResponse.percentageOfTcp ? `${yearPaidResponse.percentageOfTcp}%` : '-';
          reportEntry[`${year}-Land Cost`] = yearCostResponse.landCostAmount ? yearCostResponse.landCostAmount : '-';
          reportEntry[`${year}-Land Development Cost`] = yearCostResponse.landDevCostAmount ? yearCostResponse.landDevCostAmount : '-';
          reportEntry[`${year}-Construction Cost`] = yearCostResponse.constructionCostAmount ? yearCostResponse.constructionCostAmount : '-';
          totalLandCost += yearCostResponse.landCostAmount ? Number(yearCostResponse.landCostAmount) : 0;
          totalLandDevCost += yearCostResponse.landDevCostAmount ? Number(yearCostResponse.landDevCostAmount) : 0;
          totalConstructionCost += yearCostResponse.constructionCostAmount ? Number(yearCostResponse.constructionCostAmount) : 0;
        })

        const totalPaidResponse = await getUnitTotalPaidRequest(unitInstance._id, null);
        reportEntry[`Total-Amount Paid`] = totalPaidResponse.amountPaid ? totalPaidResponse.amountPaid : '-';
        reportEntry[`Total-%`] = totalPaidResponse.percentageOfTcp ? `${totalPaidResponse.percentageOfTcp}%` : '-';
        reportEntry[`Total-Land Cost`] = totalLandCost;
        reportEntry[`Total-Land Development Cost`] = totalLandDevCost;
        reportEntry[`Total-Construction Cost`] = totalConstructionCost;

        return reportEntry;
      });

      exportToExcel({
        data: reportEntries,
        fileName: "unit-cost-report"
      })
  
      this.setState({ 
        isLoading: false,
        successMessage: "Report generated successfully"
      });

    } catch(error) {
      console.log("Error generating unit cost report", error);
      this.setState({ 
        isLoading: false,
        errorMessage: "An error occurred while generating the report. Please try again." 
      });

    };
  }

  generateZeroVatClientsReport = async () => {
    console.log("Generating zero VAT clients report...");

  }


  render() {

    const steps = [
      {
        stepName: "Type",
        stepIcon: "tim-icons icon-single-copy-04",
        component: Step1,
        stepProps: {
          reportType: this.state.reportType,
          setReportType: this.setReportType
        }
      },
      {
        stepName: "Filters",
        stepIcon: "tim-icons icon-bullet-list-67",
        component: Step2,
        stepProps: {
          reportType: this.state.reportType,
          landCostPerSqm: this.state.landCostPerSqm,
          constructionCostPerSqm: this.state.constructionCostPerSqm,
          onChangeField: this.onChangeField
        }
      },
      {
        stepName: "Generate",
        stepIcon: "tim-icons icon-upload",
        component: Step3,
        stepProps: {
          reportType: this.state.reportType,
          isLoading: this.state.isLoading,
          successMessage: this.state.successMessage,
          errorMessage: this.state.errorMessage,
          landCostPerSqm: this.state.landCostPerSqm,
          constructionCostPerSqm: this.state.constructionCostPerSqm,
          generateReport: this.generateReport
        }
      }
    ];

    return (
      <>
        <div className="content">
          <Col className="mr-auto ml-auto" md="10">
            <StepWizard>
              <Step1 {...steps[0].stepProps} />
              <Step2 {...steps[1].stepProps} />
              <Step3 {...steps[2].stepProps} />
            </StepWizard>
          </Col>
        </div>
      </>
    );
  }
}

export default Reports;
